import React, { useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { spread } from "axios";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("İsim gerekli"),
  lastName: Yup.string().required("Soyisim gerekli"),
  email: Yup.string().email("Geçersiz email").required("Email gerekli"),
  password: Yup.string()
    .min(6, "Şifre en az 6 karakter olmalı")
    .required("Şifre gerekli"),
});

function MyForm() {
  const [errors, setErrors] = useState({});
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };
  const notify = () => {
    toast("Form submit is success but not stored in database!", {
      position: toast.POSITION.TOP_LEFT,
      className: "toast-message",
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    validationSchema
      .validate(values)
      .then(() => {
        console.log("Değerler geçerli", values);
      })
      .catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });
        setErrors(newErrors);
      });
  };

  const isSubmitDisabled = () => {
    try {
      validationSchema.validateSync(values, { abortEarly: false });
      return false;
    } catch (error) {
      return true;
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Firstname: {errors.firstName && <span>{errors.firstName}</span>}
        <input
          type="text"
          name="firstName"
          value={values.firstName}
          onChange={handleChange}
        />
      </label>
      <label>
        Lastname: {errors.lastName && <span>{errors.lastName}</span>}
        <input
          type="text"
          name="lastName"
          value={values.lastName}
          onChange={handleChange}
        />
      </label>
      <label>
        Email: {errors.email && <span>{errors.email}</span>}
        <input
          type="email"
          name="email"
          value={values.email}
          onChange={handleChange}
        />
      </label>
      <label>
        Password: {errors.password && <span>{errors.password}</span>}
        <input
          type="password"
          name="password"
          value={values.password}
          onChange={handleChange}
        />
      </label>
      <button onClick={notify} type="submit" disabled={isSubmitDisabled()}>
        Gönder
      </button>
    </form>
  );
}

export default MyForm;
